/** The widget build, sent with every report and shown at the bottom of the settings flyout. */
export const VERSION = '0.3.0';
